/* eslint-disable jsx-a11y/anchor-has-content */
import InsuranceCompaniesFile from 'assets/files/insurance-companies.pdf'
import InfoSolidIcon from 'assets/icons/info-solid.svg?component'
import InfoBlock from 'components/UI/Blocks/InfoBlock'
import RadioGroup from 'components/UI/RadioGroup'
import Typography from 'components/UI/Typography'
import { InsuranceCompanies } from 'pages/Decision/constants'
import { Fragment, useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tooltip'
import tw from 'twin.macro'

const LoanInsurance = ({
  insurance,
  onInsuranceChange
}: {
  insurance: InsuranceCompanies
  onInsuranceChange: (val: InsuranceCompanies) => void
}) => {
  const { t } = useTranslation()

  // Custom hooks
  const insuranceCompanies = useMemo(
    () => [
      {
        value: InsuranceCompanies.freedom,
        content: (
          <Typography twStyle={tw`space-x-4`} variant='subbody' weight='medium'>
            <span>{t('loan-insurance.freedom-insurance')}</span>
            <span tw='text-grey-dark dark:text-grey-light'>+0,1%</span>
          </Typography>
        )
      },
      {
        value: InsuranceCompanies.other,
        content: (
          <Fragment>
            <Typography twStyle={tw`flex gap-x-4`} variant='subbody' weight='medium'>
              <span>{t('loan-insurance.other-insurance')}</span>
              <span>
                <InfoSolidIcon data-tooltip-id='info-icon' />
              </span>
            </Typography>
            <Tooltip
              id='info-icon'
              tw='!bg-tooltip !text-main !p-3 shadow-[0px 4px 10px 0px #00000040]'
              clickable
              opacity={1}
              place='bottom'
            >
              <Trans
                i18nKey='loan-insurance.tooltip-text'
                components={{
                  1: (
                    <a
                      tw='font-semibold text-primary underline'
                      download
                      href={InsuranceCompaniesFile}
                      target='_blank'
                      rel='noreferrer'
                    />
                  )
                }}
              />
            </Tooltip>
          </Fragment>
        )
      }
    ],
    [t]
  )

  return (
    <InfoBlock twStyle={tw`space-y-4`}>
      <Typography weight='bold'>{t('loan-insurance.title')}</Typography>
      <RadioGroup
        withoutDivider
        withoutSelectedBackground
        twStyle={tw`space-y-3`}
        labelStyle={tw`px-0 py-1 gap-x-4`}
        groupName='insurance'
        value={insurance}
        onChange={onInsuranceChange}
        options={insuranceCompanies}
      />
    </InfoBlock>
  )
}

export default LoanInsurance
